import React, { useEffect, useState } from 'react';
import '../../css/Dashboard.css';
import { useDashboardData } from '../SalesDashboard/DashboardDataContext';

interface DepartingPackagesProps {
  onCustomerClick: (customerId?: number) => void;
}

const DepartingPackages: React.FC<DepartingPackagesProps> = ({ onCustomerClick }) => {
  const [items, setItems] = useState<{ title: string; date: string; customer: string; customerId?: number | string }[]>([]);
  const { data } = useDashboardData();
  useEffect(() => {
    if (!data) return;
    const list = (data.departures || []).map(d => ({
      title: d.title,
      date: new Date(d.date).toLocaleDateString(),
      customer: d.customer,
      customerId: d.customerId,
    }));
    setItems(list);
  }, [data]);

  return (
    <>
      <h4 className="card-title">Departing This Week</h4>
      <ul className="list">
        {items.map((it, i) => (
          <li key={i} className="list-item" style={{ display:'block' }}>
            <div className="li-title">{it.title}</div>
            <div className="li-sub">
              Customer: {it.customerId ? (
                <button type="button" className="dashboard-customer-link" onClick={() => onCustomerClick(Number(it.customerId))}>
                  {it.customer}
                </button>
              ) : it.customer} · Departure: {it.date}
            </div>
          </li>
        ))}
      </ul>
    </>
  );
};

export default DepartingPackages;
